import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";

function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) navigate("/admin");
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#080808] px-6">
      <div className="w-full max-w-sm">
        <p className="mb-2 text-[11px] uppercase tracking-[0.4em] text-white/50">Admin</p>
        <h1 className="mb-8 font-display text-4xl font-extrabold uppercase tracking-tight text-white">
          Sign in
        </h1>
        <form onSubmit={submit} className="space-y-5">
          <div>
            <Label className="text-white/60" htmlFor="email">Email</Label>
            <Input
              id="email"
              data-testid="login-email-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-2 border-white/20 bg-[#111] text-white"
              required
            />
          </div>
          <div>
            <Label className="text-white/60" htmlFor="password">Password</Label>
            <Input
              id="password"
              data-testid="login-password-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-2 border-white/20 bg-[#111] text-white"
              required
            />
          </div>
          {error && (
            <p data-testid="login-error" className="text-sm text-red-400">{error}</p>
          )}
          <Button
            data-testid="login-submit-btn"
            type="submit"
            disabled={loading}
            className="w-full rounded-full bg-white py-6 font-bold uppercase tracking-wide text-black hover:bg-white/90"
          >
            {loading ? "Signing in…" : "Sign in"}
          </Button>
        </form>
      </div>
    </div>
  );
}
